var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/document-renewal-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-20218735!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/document-renewal-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentRenewalList.vue
// module id = 616
// module chunks = 1